<template>
  <q-dialog ref="dialog" @hide="onDialogHide" :persistent="persistent">
    <q-card :class="`q-dialog-plugin ${dialogBackground}`">
      <!-- HEADER -->
      <q-toolbar :class="`bg-${dialogColor} ${dialogToolbarTextColor}`">
        <q-btn
          v-if="showCloseButton || form"
          icon="mdi-close"
          padding="4px"
          round
          flat
          :color="dialogToolbarTextColor"
          @click="onCancelClick"
          tabindex="-1"
        ></q-btn>
        <q-icon v-if="icon" :name="icon" size="26px"></q-icon>
        <q-toolbar-title>{{ dialogTitle }}</q-toolbar-title>
      </q-toolbar>
      <!-- <q-separator v-if="flat"></q-separator> -->

      <!-- MENSAGENS -->
      <q-card-section v-if="message">
        <div v-if="html" v-html="message"></div>
        <div v-else>
          {{ message }}
        </div>
      </q-card-section>

      <!-- FORMULÁRIOS -->
      <q-card-section v-if="form">
        <system-form
          :fields="form"
          submitLabel="OK"
          @submit="internalOnSubmit"
        ></system-form>
      </q-card-section>

      <!-- FOOTER -->
      <q-separator v-if="flat"></q-separator>
      <q-card-actions
        v-if="!form"
        align="right"
        :class="flat ? 'bg-white' : ''"
      >
        <q-btn :color="dialogMainButtonColor" label="OK" @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import form from "./form/form";
import { defineComponent } from "vue";

export default defineComponent({
  name: "system-dialog",

  props: {
    backgroundColor: {
      type: String,
    },
    color: {
      type: String,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
    },
    html: {
      type: Boolean,
    },
    icon: {
      type: String,
    },
    message: {
      type: String,
    },
    onSubmit: {
      type: Function,
      default() {
        console.warn("Nenhuma função foi passada para o formulário.");
      },
    },
    persistent: {
      type: Boolean,
    },
    showCloseButton: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    type: {
      type: String,
    },
  },

  computed: {
    dialogBackground() {
      return `bg-${this.backgroundColor}` ?? "bg-white";
    },

    dialogColor() {
      // verifica se o design é flat

      if (this.color) return this.color;
      if (this.type) {
        if (this.type === "error") return "negative";
      }
      return "primary";
    },

    dialogMainButtonColor() {
      if (this.color) return this.color;
      if (this.type) {
        if (this.type === "error") return "negative";
      }
      return "primary";
    },

    dialogTitle() {
      if (this.title) return this.title;
      if (this.type) {
        if (this.type === "error") return "Erro";
      }
      return "Aviso";
    },

    dialogToolbarTextColor() {
      if (this.flat) return "text-grey-8";
      return "text-white";
    },
  },

  components: {
    "system-form": form,
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      // this.$emit("hide");
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit("ok");
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },

    internalOnSubmit(params) {
      this.hide();
      this.onSubmit(params);
    },
  },
});
</script>